export default __webpack_public_path__ + "static/media/splash-loading.77fe6f23.svg";